import styled from 'styled-components';
import { rem } from '../../utils';
export const StyledDropDownMenu = styled.div `
  width: fit-content;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  user-select: none;
  ${({ fixedHeight }) => fixedHeight &&
    `
    height: ${rem(fixedHeight)};
    overflow-y: scroll;
    align-items: flex-start;
`}
`;
export const StyledMenuItemWrapper = styled.div `
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  background-color: ${({ theme, variant }) => variant === 'selected' ? theme.Color.Brand.Lightest : 'transparent'};
  justify-content: space-between;
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.XXSmall)}
    ${rem(theme.Spacing.Size.Small)}`};
  border-radius: ${({ theme }) => rem(theme.Border.Radius.XSmall)};
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'disabled' : 'pointer')};

  &:hover {
    background-color: ${({ theme, variant }) => variant === 'default' && theme.Components.Panel.BackgroundHover};
  }
`;
export const StyledMenuItemSideWrapper = styled.div `
  align-items: center;
  flex: 0 0 auto;
`;
export const StyledMenuItemCenterWrapper = styled.div `
  display: flex;
  align-items: center;
  flex: 1 1 auto;
`;
export const StyledCustomDropdownItemWrapper = styled.div ``;
//# sourceMappingURL=DropdownNext.style.js.map